export default {
  host: "",
  audio: {
    play: function () {
      alert('Уведомление');
    }
  },
  localizations: [],
  features: {
    icon: [],
    text: [],
  },
  languages: {
    "ru": "RUS",
    "uz": "UZB",
    "en": "ENG",
  },
  language_current: "ru",
  shop: null,
  ticket: {},
  location: {},
  lastMessage: {},
  roles: {},
  post: null,
  text: {

  },
  stats: [],
  routes: {},
  shedules: {},
  language: "ru",
  checked: null,
  business: null,
  user: null,
  root: null,
  newOrder: null,
  modals: {
    variant: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: false,
      removeLink: "",
      cardLink: "",
      itemLink: "variants",
      setLink: "",
      columns: [
        {
          key: "barcode",
          titleKey: "barcode",
          title: "Баркод",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "name",
          titleKey: "name",
          title: "Название",
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "stock",
          titleKey: "stock_price",
          title: "Цена",
          object: "price",
          control: false,
          align: "left",
          timer: false,
          disableLink: true,
        },
        {
          key: "stock",
          titleKey: "stock_quantity",
          title: "На складе",
          object: "quantity",
          control: false,
          align: "left",
          timer: false,
          disableLink: true,
        },
      ],
      params: null,
    },
    status: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "",
      itemLink: "statuses",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Статус",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: { is_active: true },
    },
    organization: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "organizations",
      cardLink: "organizations",
      itemLink: "organizations",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Статус",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: null,
    },
    bank: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "banks",
      cardLink: "banks",
      itemLink: "banks",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Название",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: null,
    },
    system: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "systems",
      cardLink: "systems",
      itemLink: "systems",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Название",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: null,
    },
    purchase: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "barcode",
          title: "Баркод",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "name",
          title: "Товар",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: null,
    },
    service: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "banks",
      cardLink: "services",
      itemLink: "services",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Название",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: null,
    },
    "trade-in": {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "trade_ins",
      itemLink: "trade_ins",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Устройство",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "price",
          title: "Скидка",
          control: false,
          price: true,
          align: "left",
          timer: false,
        },
      ],
      params: null,
    },
    partner: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "",
      itemLink: "partners",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Партнер",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: { is_active: true },
    },
    role: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "",
      itemLink: "roles",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Роль",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "sections",
          object: "name",
          title: "Экраны",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
      ],
      params: { is_active: true },
    },
    user: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: false,
      removeLink: "",
      cardLink: "",
      itemLink: "users",
      setLink: "",
      columns: [
        {
          checkbox: true,
          key: "name",
          titleKey: "name",
          title: "Имя",
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "phone",
          titleKey: "phone",
          title: "Номер телефона",
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: { is_active: true },
    },
    order: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: false,
      removeLink: "",
      cardLink: "",
      itemLink: "orders",
      setLink: "",
      columns: [
        {
          checkbox: true,
          key: "id",
          title: "ID",
          titleKey: "id",
          control: false,
          align: "left",
          timer: false,
        },

      ],
      params: { is_active: true },
    },
    client: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: false,
      removeLink: "",
      cardLink: "",
      itemLink: "clients",
      setLink: "",
      columns: [
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "first_name",
          title: "Имя",
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "last_name",
          title: "Фамилия",
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: { is_active: true },
    },
    section: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "",
      itemLink: "sections",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Экран",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: { is_active: true },
    },
    product: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "",
      itemLink: "products",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Название",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "brand",
          title: "Бренд",
          disableLink: true,
          checkbox: false,
          control: false,
          object: "name",
          timer: false,
          detail: false,
        },

        {
          key: "vendor_code",
          title: "Артикул",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
      ],
      params: null,
    },
    conditional: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "",
      itemLink: "conditionals",
      setLink: "",
      columns: [
        {
          key: "title",
          title: "Условия",
          disableLink: true,
          checkbox: true,
          control: false,
          timer: false,
          detail: false,
        }
      ],
      params: null,
    },
    brand: {
      modalCreate: "",
      fields: [
        {
          col: 'col-12',
          label: 'Название',
          key: 'name',
          type: 'field'
        }
      ],
      isAdd: true,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "",
      itemLink: "brands",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Название",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: null,
    },
    category: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "",
      itemLink: "categories",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Название",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: null,
    },
    tariff: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "",
      itemLink: "tariffs",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Название",
          titleKey: "name",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "description",
          title: "Описание",
          titleKey: "description",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: null,
    },
    subcategory: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "",
      itemLink: "subcategories",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Название",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "category",
          title: "Главная категория",
          disableLink: true,
          object: "name",
          align: "left",
          timer: false,
        },
      ],
      params: null,
    },
    dealer: {
      modalCreate: "",
      fields: [],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "",
      cardLink: "",
      itemLink: "dealers",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Название",
          checkbox: true,
        },
        {
          key: "phone",
          title: "Контактный номер",
        },
        {
          key: "tin",
          title: "ИНН",
        },
        {
          key: "user",
          object: "name",
          title: "Отвественный сотрудник",
        },
      ],
      params: null,
    },
    info_project: {
      modalCreate: "",
      fields: [
        // {
        //   key: "title",
        //   col: "col-12",
        //   label: "Название",
        //   labelKey: "title",
        //   isMultiLang: true,
        //   type: "field",
        // },
      ],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "info_projects",
      cardLink: "info_projects",
      itemLink: "info_projects",
      setLink: "",
      columns: [
        {
          key: "title",
          title: "Выберите проект",
          checkbox: true,
        },

      ],
      params: null,
    },
    ticket_rubric: {
      modalCreate: "",
      fields: [
        {
          key: "name",
          col: "col-12",
          label: "Название",
          labelKey: "title",
          type: "field",
        },
      ],
      isAdd: true,
      openItem: false,
      isUpdate: false,
      searchDisable: true,
      removeLink: "ticket_rubrics",
      cardLink: "ticket_rubrics",
      itemLink: "ticket_rubrics",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Выберите проект",
          checkbox: true,
        },

      ],
      params: null,
    },
    shop: {
      modalCreate: "",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "name",
          labelKey: "name",
          label: "Название магазина",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "address",
          labelKey: "address",
          label: "Адрес",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "coords",
          label: "Отметка на карте",
          type: "map",
        },
      ],
      isAdd: false,
      openItem: false,
      isUpdate: false,
      searchDisable: false,
      removeLink: "",
      cardLink: "shops",
      itemLink: "shops",
      setLink: "shops",
      columns: [
        {
          key: "name",
          title: "Название",
          checkbox: true,
          control: false,
          align: "left",
          timer: false,
        },
      ],
      params: null,
    },
  },
  modalName: null,
  valueSelected: null,
  lastUpdate: null,
  items: {
    item_order: "Order",

    item_order_log: "OrderLog",
    item_subscription_log: "SubscriptionLog",
    item_brand: "Brand",
    item_product: "Product",
    item_variant: "Variant",
    item_client: "Client",
    item_status: "Status",
    item_purchase: "Purchase",
    item_user: "User",
    item_shop: "Shop",
    item_partner: "Partner",
    item_category: "Category",
    item_conditional: "Conditional",
    item_role: "Role",
    item_section: "Section",
    item_dealer: "Dealer",
    item_promotion: "Promotion",
    item_organization: "Organization",
    item_log: "Log",
    item_bank: "Bank",
    item_loan: "Loan",
    item_certificate: "Certificate",
    item_service: "Service",
    item_calc: "Calc",
    item_calculator: "Calculator",
    item_system: "System",
    item_system_key: "SystemKey",
    item_system_function: "SystemFunction",
    item_personal_dealer: "PersonalDealer",
    item_subscription: "Subscription",
    item_info: "Info",
    item_get_info: "GetInfo",
    item_word: "Word",
    item_tariff: "Tariff",
    item_trade_in: "TradeIn",
    item_trade_in_info: "TradeInInfo",
    item_ticket: "Ticket",
    item_insurance_order: "InsuranceOrder",
    item_certified_check: "CertifiedCheck",
    item_order_service: "OrderService",
    item_info_project: "InfoProject",
    item_info_project_info: "InfoProjectInfo",
    item_info_project_info_flow: "InfoProjectInfoFlow",
    item_partner_order: "PartnerOrder",
    item_alif_order: "AlifOrder",
    item_ticket_rubric: "TicketRubric",
    item_transfer: "Transfer",
    item_transfer_container: "TransferContainer",
    item_registry_report: "RegistryReport",
    item_registry_template: "RegistryTemplate",
  },
};
